// Used to determine if the user should be allowed to create a new export
// Baseline time: Jan 16, 2015 @ 00:15 UTC
const JOB_INITIATE_TIME_BASELINE = 1421367300000;
const DAY_MILLISECONDS = 86400000;

const ExportUtils = {
  isLastExportStale(lastJobStartTime: $TSFixMe, now: $TSFixMe) {
    const daysToNow = Math.floor((now - JOB_INITIATE_TIME_BASELINE) / DAY_MILLISECONDS);
    const daysToLastExport = Math.floor((lastJobStartTime - JOB_INITIATE_TIME_BASELINE) / DAY_MILLISECONDS);
    return daysToNow > daysToLastExport;
  },

  getMidnightUTCTimestamp(timestamp: $TSFixMe) {
    const date = new Date(timestamp);

    date.setUTCHours(0);
    date.setUTCMinutes(0);
    date.setUTCSeconds(0);
    date.setUTCMilliseconds(0);

    return date.getTime();
  },

  getMidnightUTCDateTime(timestamp: $TSFixMe) {
    const currentLocale = 'en-US';
    const formatOptions = {
      weekday: 'long',
      month: 'numeric',
      year: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      timeZoneName: 'short',
    };
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '{ weekday: string; month: string... Remove this comment to see the full error message
    const formatSpec = new Intl.DateTimeFormat(currentLocale, formatOptions);

    return formatSpec.format(new Date(this.getMidnightUTCTimestamp(timestamp)));
  },
};

export default ExportUtils;

export const { isLastExportStale, getMidnightUTCTimestamp, getMidnightUTCDateTime } = ExportUtils;
